module.exports = __webpack_public_path__ + "img/case_check.45382854.svg";